import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import backend from 'utils/backend';

const WorkflowSync = (props) => {
  const {
    user,
    playbooksLoadData,
    skillsLoadSkills,
  } = props;

  React.useEffect(() => {
    const loadWorkflowData = async () => {
      try {
        const result = await backend.workflow.getAll();

        playbooksLoadData(result?.playbooks || []);

        skillsLoadSkills(result?.skills || []);
      } catch (error) {
        console.error('Failed to sync workflow data', error);
      }
    };

    if (user?.userRn) {
      loadWorkflowData();
    }
  }, [user]);

  return null;
};

WorkflowSync.propTypes = {
  user: PropTypes.object,
  playbooks: PropTypes.object.isRequired,
  skills: PropTypes.object.isRequired,
  playbooksLoadData: PropTypes.func.isRequired,
  skillsLoadSkills: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  user: state.user,
  playbooks: state.playbooks,
  skills: state.skills,
});

export default connect(mapStateToProps, dispatch)(React.memo(WorkflowSync));
